import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './services/core/auth.services';

@Component({
  selector: 'body',
  standalone: false,
  templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit {
  locale = 'es';

  constructor(private readonly router: Router, public translate: TranslateService, public auth: AuthService) {
    this.translate.addLangs(['es', 'en']);
    this.translate.setDefaultLang('es');
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang.match(/es|en/) ? browserLang : 'es');
    this.locale = this.translate.currentLang;
  }

  ngOnInit() {
    this.router.events.subscribe(evt => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
